<!-- TESTIMONIALS -->
<section class="testimonial text-center">
    <div class="container">

        <div class="heading white-heading">
            Testimonials
        </div>
        <div id="testimonial4" class="carousel slide testimonial4_indicators testimonial4_control_button thumb_scroll_x swipe_x" data-ride="carousel" data-pause="hover" data-interval="5000" data-duration="2000">
         
            <div class="carousel-inner" role="listbox">
                <div class="carousel-item active">
                    <div class="testimonial4_slide">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/unnamed.png" class="img-circle img-responsive" />
                        <div class="testi">
                            <p>During the different stages of the event, we went through different learnings and lots of mentorships, at the same time it gave us an opportunity to network/ connect with very resourceful individuals with whom we are still connected. Being a winner, we were taken to Dubai-Expo-2020, which was one of the great opportunities we received.
                            </p>
                            <h4>BlisCare</h4>
                            <h4>Salesken Business Track Winner</h4>
                        </div> 
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="testimonial4_slide">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/curomatesLogoWhite.png" class="img-circle img-responsive" />
                        <div class="testi">
                            <p>Eureka by IITB, provides the framework required to shape your idea into a real world startup and a platform to network, learn from experts. The different stages of Eureka help refine the idea, make experiments and gain more insights about your hypothesis. Mentors allotted provided us with useful suggestions during our connect sessions. Also, the offline networking events were well organized.
                            </p>
                            <h4>Curomates</h4>
                            <h4>SIDBI Social Track Winner</h4>
                        </div> 
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="testimonial4_slide">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/Twitter Header Photo.png" class="img-circle img-responsive" />
                        <div class="testi">
                            <p>Our interactions with the associated mentors at semi-final and final stages were very insightful. Post Eureka! 21, we were privileged to start our discussion with the main sponsor of the Fintech Track (SBI General Insurance) for an industry project with them. This signifies that Eureka! is not merely an entrepreneurial event but is a holistic startup ecosystem which nurtures the deserving ideas into an industry ready entity.
                            </p>
                            <h4>DocEye</h4>
                            <h4>SBI General FinTech Track Winner</h4>
                        </div> 
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="testimonial4_slide">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/AI-Genex logo tagline white BG.jpg" class="img-circle img-responsive" />
                        <div class="testi">
                            <p>After we identified a real world social problem, Eureka! indeed played a significant role in our entrepreneurial journey. We got an access to world-class mentors, the much-needed customer connections, and the opportunity to present our project to domestic and foreign investors.
                            </p>
                            <h4>AI-Genix</h4>
                            <h4>Godrej Agrovet Food and Agro Track Winner</h4>
                        </div> 
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="testimonial4_slide">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/2new.png" class="img-circle img-responsive" />
                        <div class="testi">
                            <p>Registering for Eureka was one of the best decisions we ever took! We were invited to offline events, pitch sessions and were also connected with diverse industry leaders to help improve our idea. The process in itself made us introspect about the direction of the venture and motivated us to iterate our model for the better - all before we even reached the final round. Appreciate all the good work initiated by E-Cell team of IIT Bombay!
                            </p>
                            <h4>MyWays</h4>
                            <h4>GII Edutech Track Winner                            </h4>
                        </div> 
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#testimonial4" data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next" href="#testimonial4" data-slide="next">
                <span class="carousel-control-next-icon"></span>
            </a>
        </div>
    </div>
</section>
